
export default class GoogleAnalytics {
  constructor() {
  }
  #isenvironmentinitialized = false

  gaEventTrigger(eventName,datalayer) {
    const newDataLayer = {
        event: eventName,
        ...datalayer
    }
    this.datapushtoTagManager(newDataLayer)
  }
   datapushtoTagManager(datalayer) {
    let is_secure_privacy_applicable = JSON.parse(localStorage.getItem('is_secure_privacy_enabled'))
    if(is_secure_privacy_applicable === false || is_secure_privacy_applicable === null ){
      window.dataLayer.push(datalayer)
    }
    else if(is_secure_privacy_applicable === true && this.userConsentProvided()=== true){
      window.dataLayer.push(datalayer)
    }
  }

  setEnvironment(environment){
  if(this.isenvironmentinitialized){
    throw Error ('Google Environment is already initatialized ')
  }
  this.isenvironmentinitialized=true;
  window.dataLayer.push({event: "gtm.js", env:environment})
  }
  userConsentProvided() {
    let spConsent = localStorage.getItem('sp_consent')
    if (spConsent) {
      spConsent = JSON.parse(spConsent)
    }
    const spConsentAnalytics = spConsent?.AllConsents?.find((obj) => obj.ComplianceType === 'Analytics')
    let spConsentAnalyticsList = []
    let spConsentGoogleAnalytics =  null
    let isGoogleAnalyticsEnabled = null
    if (spConsentAnalytics) {
      spConsentAnalyticsList = JSON.parse(spConsentAnalytics.PluginPreferences)
      spConsentGoogleAnalytics = spConsentAnalyticsList?.find((obj) => obj.ComplianceType === 'Google Analytics')
      isGoogleAnalyticsEnabled = !spConsentGoogleAnalytics?.IsBlockEnabled
    }
    return (spConsentAnalytics && spConsentGoogleAnalytics && isGoogleAnalyticsEnabled) || false;
  }

}